export default __webpack_public_path__ + "static/macbook-af8aa3767af7c19548e6febc11d7e023.png";